<template>
    <div class="datetime-history">
        <div class="datetime">
            <div class="date">
                <v-menu
                    v-model="menu_date_1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{ on }">
                        <v-text-field
                            v-model="date_1"
                            readonly
                            v-on="on"
                        >
                            <div class="v-input__icon v-input__icon--append" 
                                slot="append"
                            >
                                <v-icon color="black">
                                    icon-time-setting
                                </v-icon>
                            </div>
                        </v-text-field>
                    </template>

                    <v-date-picker 
                        v-model="model_date_1"
                        :locale="language !== 'en'? 'zh-tw' : 'en' "
                        :day-format="date => date.split('-')[2]"
                        :min="min_case_date"
                        :max="max_date_1"
                    >
                        <v-spacer />
                        <v-btn
                            text
                            color="primary"
                            @click="cancel_date_pick_1"
                        >
                            {{ $t('__time_choose.cancel') }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="update_date_by_user_1"
                        >
                            {{ $t('__time_choose.decide') }}
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>   
        </div>
        <div style="margin: 0 10px;">
            ~
        </div>
        <div class="datetime">
            <div class="date">
                <v-menu
                    v-model="menu_date_2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{ on }">
                        <v-text-field
                            v-model="date_2"
                            readonly
                            v-on="on"
                        >
                            <div class="v-input__icon v-input__icon--append" 
                                slot="append"
                            >
                                <v-icon color="black">
                                    icon-time-setting
                                </v-icon>
                            </div>
                        </v-text-field>
                    </template>

                    <v-date-picker 
                        v-model="model_date_2"
                        :locale="language !== 'en'? 'zh-tw' : 'en' "
                        :day-format="date => date.split('-')[2]"
                        :min="min_case_date"
                        :max="max_date_2"
                    >
                        <v-spacer />
                        <v-btn
                            text
                            color="primary"
                            @click="cancel_date_pick_2"
                        >
                            {{ $t('__time_choose.cancel') }}
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="update_date_by_user_2"
                        >
                            {{ $t('__time_choose.decide') }}
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </div>
        </div>
    </div>
</template>

<script>
    import { 
        timestamp_to_date,
        timestamp_to_time,
        compute_case_limit_time,
    } from '@/utils/case/case.js'
    import { mapGetters, mapState } from 'vuex'
    import { STATIC_SVG_ROOT } from '@/config/config.js'
    export default {
        name: 'QpeDatetimeHistory',
        props: {
            props_date: {
                type:String,
                default () {
                    return new Date(+new Date() + 8* 3600000).toISOString().substr(0, 10)
                }
            },
        },
        data() {
            return {
                date_1: new Date((new Date().setDate(new Date().getDate() - 2)) + 8* 3600000).toISOString().substr(0, 10),
                model_date_1: new Date((new Date().setDate(new Date().getDate() - 2)) + 8* 3600000).toISOString().substr(0, 10),
                menu_date_1: false,
                max_date_1: new Date((new Date().setDate(new Date().getDate() - 1)) + 8* 3600000).toISOString().substr(0, 10),

                date_2: new Date((new Date().setDate(new Date().getDate() - 1)) + 8* 3600000).toISOString().substr(0, 10),
                model_date_2: new Date((new Date().setDate(new Date().getDate() - 1)) + 8* 3600000).toISOString().substr(0, 10),
                menu_date_2: false,
                max_date_2: new Date((new Date().setDate(new Date().getDate() - 1)) + 8* 3600000).toISOString().substr(0, 10),

                STATIC_SVG_ROOT: STATIC_SVG_ROOT,

                date_list:[],
            }
        },
        computed: {
            ...mapState([
                'language',
            ]),

            ...mapState('monitor', [
                'time_interval',
            ]),
            
            ...mapState('case', [
                'case_selected'
            ]),

            ...mapGetters('monitor', [
                'is_show_time_choose_field'
            ]),

            ...mapGetters('case', [
                'is_case_mode'
            ]),

            min_case_date() {
                return this.is_case_mode ? timestamp_to_date(this.case_selected.start) : ''
            },

            max_date() {
                if (this.is_case_mode) {
                    return timestamp_to_date(this.case_selected.end)
                }

                const today_date = timestamp_to_date()                
                return today_date
            },

            min_case_time() {
                return !this.is_case_mode ? "" : compute_case_limit_time(this.case_selected.start, this.date)
            },
            
            max_time() {
                if (this.is_case_mode) {
                    return compute_case_limit_time(this.case_selected.end, this.date)
                }

                const today_date = timestamp_to_date()
                return this.date === today_date ? timestamp_to_time() : ''
            }
        },
        mounted () {
            this.get_date_list();
        },
        watch: {
            props_date: {
                handler(date_value) {
                    this.date = date_value || this.date
                    this.model_date = date_value || this.model_date
                },
                immediate: true
            },

            date_1: {
                handler(newV, oldV) {
                    if (newV !== oldV) {
                        // day_interval 是開始日期 ~ 結束日期的間隔天數
                        let day_interval = (new Date(this.date_2) - new Date(newV)) / 1000 / 60 / 60 / 24;
                    
                        // date_1 ~ date_2 超過 10 天
                        if (day_interval > 9) {
                            console.log('date_1 ~ date_2 超過 10 天')
                            this.$emit('open_hint_dialog');
                            this.date_1 = oldV;
                            this.model_date_1 = this.date_1;

                        // date_1 ~ date_2 沒有超過 10 天
                        } else {
                            this.get_date_list(); 
                        }
                    }
                },
                deep: true
            },

            date_2: {
                handler(newV, oldV) {
                    if (newV !== oldV) {
                        // day_interval 是開始日期 ~ 結束日期的間隔天數
                        let day_interval = (new Date(newV) - new Date(this.date_1)) / 1000 / 60 / 60 / 24;
                    
                        // date_1 ~ date_2 超過 10 天
                        if (day_interval > 10) {
                            console.log('date_1 ~ date_2 超過 10 天')
                            this.$emit('open_hint_dialog');
                            this.date_2 = oldV;
                            this.model_date_2 = this.date_2;

                        // date_1 ~ date_2 沒有超過 10 天
                        } else {
                            this.get_date_list(); 

                            // 當 date_2 改變時，調整 date_1 可選取的最大日期
                            this.max_date_1 = new Date((new Date(newV).setDate(new Date(newV).getDate())) + 8* 3600000).toISOString().substr(0, 10)
            
                            // 當新選擇的 date_2 < 原本的 date_1，將 date_1 設定成跟 date_2 同一天
                            if (new Date(newV) < new Date(this.date_1)) {
                                this.date_1 = newV;
                                this.model_date_1 = this.date_1;
                            }
                        }
                    }
                },
                deep: true
            },

        },
        methods: {
            cancel_date_pick_1() {
                this.menu_date_1 = false
                this.model_date_1 = this.date_1
            },

            cancel_date_pick_2() {
                this.menu_date_2 = false
                this.model_date_2 = this.date_2
            },

            update_date_by_user_1() {
                this.menu_date_1 = false;
                this.date_1 = this.model_date_1
                this.time_1 = this.is_show_time_choose_field  ? this.time_1 : "08:00";
            },

            update_date_by_user_2() {
                this.menu_date_2 = false;
                this.date_2 = this.model_date_2
                this.time_2 = this.is_show_time_choose_field  ? this.time_2 : "08:00";
            },

            // 被放在表格的日期
            get_date_list() {
                this.date_list = [];
                let date = this.date_1;
                let d = new Date(this.date_1);
                let d_max = new Date(this.date_2);

                while (d < d_max) {
                    this.date_list.push(date);
                    date = new Date((d.setDate(d.getDate() + 1)) + 8* 3600000).toISOString().substr(0, 10);
                    d = new Date(date);
                }

                this.date_list.push(this.date_2);
                this.$emit('set_history_date_list', this.date_list)
            },
        },
        
    }
</script>

<style lang="scss" scoped>
    .datetime-history {
        display: flex;
        align-items: center;
    }

    .datetime {
        display: flex;
    }

    .date {
        width: 124px;
    }

    .time {
        margin: 0 16px;
        width: 76px;
    }
</style>

<style lang="scss">
    .date,
    .time {
        input {
            cursor: pointer;
        }
    }
</style>